import { isoZ, z } from 'my-zod'
import { productLineOptions } from '../../internal'

// asset family view is a view on top of model families and outfitter custom asset families
export const assetFamilyView = z.object({
  id: z.string(),
  outfitterId: z.number().nullable(),
  name: z.string(),
  assetClassId: z.number().nullable(),
  productLine: z.enum(productLineOptions).nullable(),
  imageUrl: z.string().nullable(),
  capacity: z.number(),
  type: z.enum(['modelFamily', 'customAssetFamily']),
  description: z.string().nullable().optional(),
  deletedDate: isoZ.instant().nullable()
})

export type assetFamilyView = z.infer<typeof assetFamilyView>
